export default __webpack_public_path__ + "static/media/nflbignew.25ceea77.png";